module.exports = __webpack_public_path__ + "img/arrow.4e713e48.png";